import { createReducer } from 'reduxsauce';
import { Types } from './actions';

const INITIAL_STATE = {
  loading: false,
  singleReview: [],
  relatedArticles: [],
  tagsList: [],
  error: null
};

// ************************* Fetch Single Review *************************
const fetchSingleReviewStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchSingleReviewSuccess = (state = INITIAL_STATE, action) => {
  let newSingleReviewArr;
  if (action.singleReview.postSlug !== null) {
    newSingleReviewArr = [...action.singleReview.singleReview];
  } else {
    newSingleReviewArr = [
      ...state.singleReview,
      ...action.singleReview.singleReview
    ];
  }
  return { ...state, singleReview: newSingleReviewArr, loading: false };
};

const fetchSingleReviewFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false, error: action.error };
};
// _____________________________________________________________________

// ************************* Fetch Related Articles *************************
const fetchRelatedArticlesForSingleReviewStart = (
  state = INITIAL_STATE,
  action
) => {
  return { ...state, loading: true };
};

const fetchRelatedArticlesForSingleReviewSuccess = (
  state = INITIAL_STATE,
  action
) => {
  // console.log('action: ', action);
  let newRelatedArticles, newTagList;

  // console.log('********* *********', state.singleReview);
  // console.log('********* *********', state.singleReview.length);
  // if (action.relatedArticles.length === 0) {
  //   newRelatedArticles = [...state.relatedArticles, []];
  // } else {
  newRelatedArticles = [
    // ...state.relatedArticles,
    ...action.relatedArticles.relatedArticles
  ];
  newTagList = [
    // ...state.tagsList,
    ...action.relatedArticles.tagsList
  ];
  // console.log('action.relatedArticles: ', action.relatedArticles);
  // }
  return {
    ...state,
    relatedArticles: newRelatedArticles,
    tagsList: newTagList,
    loading: false
  };
};

const fetchRelatedArticlesForSingleReviewFailure = (
  state = INITIAL_STATE,
  action
) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// Define Handlers
const HANDLERS = {
  [Types.FETCH_SINGLE_REVIEW_START]: fetchSingleReviewStart,
  [Types.FETCH_SINGLE_REVIEW_FAILURE]: fetchSingleReviewFailure,
  [Types.FETCH_SINGLE_REVIEW_SUCCESS]: fetchSingleReviewSuccess,

  [Types.FETCH_RELATED_ARTICLES_FOR_SINGLE_REVIEW_START]: fetchRelatedArticlesForSingleReviewStart,
  [Types.FETCH_RELATED_ARTICLES_FOR_SINGLE_REVIEW_FAILURE]: fetchRelatedArticlesForSingleReviewFailure,
  [Types.FETCH_RELATED_ARTICLES_FOR_SINGLE_REVIEW_SUCCESS]: fetchRelatedArticlesForSingleReviewSuccess
};

// Create and Export Reducer
export const singleReviewReducer = createReducer(INITIAL_STATE, HANDLERS);
